import { render, staticRenderFns } from "./stockin_edit.vue?vue&type=template&id=4abcc96e&scoped=true"
import script from "./stockin_edit.vue?vue&type=script&lang=js"
export * from "./stockin_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcc96e",
  null
  
)

export default component.exports